/* Modules */
import React from 'react';
import ReactDOM from 'react-dom';

/* Styles */
import 'aphrodite-ui/dist/assets/aphrodite.css';
import 'aphrodite-ui/dist/assets/aphrodite-font-family.css';
import './styles/css/index.css';

import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js